<template>
  <div id="ResourceVice">
    <van-row style="margin-left:20px;margin-right:20px;margin-top:48px">
      <van-icon />
      <van-icon style="float:left;margin-top:-31px;" name="close" size="18" @click="onClickClose()" />
      <van-icon style="float:right;margin-top:-31px;" :class="{checked:index==nowIndex}" name="like" size="18" @click="onClickGood(index)" />
    </van-row>
    <van-row style="border-bottom:1px solid;border-color:#999999;margin-left:20px;margin-right:20px">
      <van-col span="15" class="pub_title">{{ parms.article_title }}</van-col>
      <van-col style="margin-top:5px">
        <van-col style="width:200px" span="15" class="pub_time">{{ times }}</van-col>
      </van-col>
      <van-col style="float:right" class="like"><label class="view_c">{{ parms.user_name }}</label></van-col>
    </van-row>
    <video-player
      ref="videoPlayer"
      style="margin-top:10px;margin-left:20px;margin-right:20px"
      class="video-player vjs-custom-skin"
      :playsinline="true"
      :options="playerOptions"
      @play="onPlayerPlay()"
    />
    <van-row style="margin-left:20px;margin-right:20px;margin-top:20px">
      <label v-html="parms.article_content" />
    </van-row>
    <van-notify v-model="show" type="success">
      <van-icon name="bell" style="margin-right: 4px;" />
      <span>通知内容</span>
    </van-notify>
  </div>
</template>
<script>
import request from '@/utils/request'
// const moment = require('moment')
export default {
  props: {
    parms: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: '',
          src: 'http://localhost:8085/test.mp4'// url地址
        }],
        poster: 'src\views\img\main.png', // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      computed: {
        player() {
          return this.$refs.videoPlayer.player
        }
      },
      leavePage: {
        mode: true,
        info: {}
      },
      // message: this.parms.article_content,
      index: 0,
      nowIndex: 1,
      show: false,
      times: this.$parent.$parent.times,
      // parms: this.$parent.$parent.$parent.parm,
      resourceList: null
    }
  },
  watch: {
  },
  mounted() {
    if (this.parms.liked !== 0) {
      this.nowIndex = 0
    }
  },
  methods: {
    onPlayerPlay() {
      this.playerOptions['sources'][0]['src'] = 'http://localhost:8085/' + this.$parent.$parent.videoURL
    },
    // 关闭当前页面
    onClickClose() {
      this.$router.go(-1)
    },
    onFresh() {},
    // 点赞处理
    onClickGood(val) {
      const self = this
      request({
        url: 'O05/SupportAction/',
        method: 'post',
        params: {
          article_code: this.parms.article_code,
          user_code: this.$store.getters.usercode
        }
      })
        .then(function(response) {
          self.resourceList = response.data
          // 动态视频URL
          self.VideoURL = ''
          // 成功后返回
          if (response.data === '0000') {
            self.nowIndex = 0
            self.$toast.fail('您已经点赞过啦!')
          // 失败
          } else {
            self.$toast.success('点赞成功')
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style>
.pub_title{
  font-size:20px ;
}
.article_title{
    font-size: 18px;
    color: #333333;
}
.article_content{
    font-size: 14px;
    color: #797979;
}
.pub_time{
    font-size: 20px;
    color: #999999;
}
.article_user{
    font-size: 14px;
    color: #0066CC;
}
.like{
    margin-left: 20px;
    color: #333333;
}
.like_c{
    font-size: 14px;
}
.view_c{
    font-size: 14px;
    color: #333333;
}
.checked{
  color:red;
}

</style>

